export const firebaseConfig = {
  apiKey: "AIzaSyAZht_saVfdPdbdifZRxh6IKwgwG5vS9eM",
  authDomain: "proma-projectmanager.firebaseapp.com",
  projectId: "proma-projectmanager",
  storageBucket: "proma-projectmanager.firebasestorage.app",
  messagingSenderId: "1030082533718",
  appId: "1:1030082533718:web:8b35ac389107e1fd911ef7",
  measurementId: "G-JCBGYGZQ61"
};